(function ($, root, undefined) {
    $(document).ready(function() {
        $('html').removeClass('no-js');
        updateAction();
        lightboxes();
        mobile();
        nav();
        tabNav();
        locationMap();
        ajaxForm();
        tracking();
        designCenter();
        swipers();
        akelCookies();
        loader();
        floorplanFilters();
        insta();
        countdown();
        mcalc();
		singleFloorplan();
		akelLogos();
		faqs();
		blocks();
		animations();
		scrollProgress();
        updateNav();
        updateAction();
        walkIn();
        calendarWidget();
        hero();
        toolbar();
        setTimestamp();
    });
})(jQuery, this);


